import { FC, useEffect, useState, Fragment } from 'react';
import styled from './index.module.scss';
import Emarsys from '@/components/MembersDay/FY2024/Emarsys';
import getLocal from '@/app/utils/getLocal';
import gtm from '@/utils/gtm';
import { useLang } from '@/i18n';
import { loginUser } from '@/utils/cookie';
import { euSubscribeParams } from '@/constants/membersday';
import { getPrivacyPolicy } from '@/utils/common';

interface IProps {
    list?: any[];
    success?: () => void;
}

const BottomSubscribe: FC<IProps> = ({ list, success }) => {
    const { locale } = getLocal();
    const { t } = useLang('membersday.subscribe');
    const [emailA, setEmailA] = useState('');

    // 上层ActivityPreview 选择的场景 订阅需携带此参数
    let checkList = list?.filter((item) => item.checked);
    if (checkList && checkList.length > 0) {
        // 因为存在value为2，3这样的字符串 后台只接收number[]
        checkList = checkList
            .map((item) => item.value)
            .join()
            .split(',')
            .map((item) => parseInt(item));
    }

    const data = euSubscribeParams[locale] || euSubscribeParams['uk'];
    // 赋值给这个data 订阅用
    data.fields[data.fields.length - 1].value = checkList;

    useEffect(() => {
        const userData = loginUser();
        setEmailA(userData?.user?.email || '');
    }, []);

    const successCallBack = () => {
        success && success();
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: t('btnText'),
                status: 'success',
                tag: 'Agree',
            });
        } catch (e) {
            console.error(e);
        }
    };

    const errorCallback = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_submit',
            button_name: t('btnText'),
            status: 'fail',
            tag: 'Agree',
        });
    };

    return (
        <div className={`${styled.BottomSubscribe}`}>
            <Fragment key={emailA}>
                <Emarsys
                    defaultValue={emailA}
                    data={data}
                    // source={emailConf.source}
                    submitText={t('btnText')}
                    placeholder={t('placeholder')}
                    successCallback={successCallBack}
                    errorCallback={errorCallback}
                />
            </Fragment>
            <p className="protocol">
                {t.rich('protocol', {
                    line1: (text: string) => (
                        <a className="link" href={getPrivacyPolicy(locale)} target="_blank" rel="noreferrer">
                            {text}
                        </a>
                    ),
                    line2: (text: string) => (
                        <a className="link" href={`https://${locale}.ecoflow.com/policies/terms-of-service`} target="_blank" rel="noreferrer">
                            {text}
                        </a>
                    ),
                })}
            </p>
        </div>
    );
};

export default BottomSubscribe;
